module.exports = __webpack_public_path__ + "static/lokal_screenshot-cd897dd3f918ec0db4b494650333c46d.png";